import {INVOICE_LOADED} from "./ActionType";

export default function invoices(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case INVOICE_LOADED:
      return (state = payload);
      
    default:
      return state;
  }
}
